import moment from 'moment';

/**
 * @param {string} date
 * @returns {string}
 */
function dateFormated(date) {
  if(date === "TBA") {
    return date;
  }
  return moment(date).format("MMM D YYYY");
}

/**
 * @param {string} time
 * @returns {string}
 */
function convertTo24HrTime(time) {
  if(time.indexOf(' PM') !== -1) {
    let timeArr = time.slice(0, time.indexOf(' PM')).split(':');
    if(parseInt(timeArr[0]) === 12) {
      return timeArr[0] + ':' + timeArr[1];
    }
    return (parseInt(timeArr[0]) + 12) + ':' + timeArr[1];
  }
  return time.slice(0, time.indexOf(' '));
}

/**
 * @param {string[]} dates
 * @returns {string}
 */
function anyNowOrAfter(dates) {
  for(const date of dates) {
    if(moment().isSameOrAfter(date, 'day')) {
      return date;
    }
  }
  return dates[dates.length - 1];
}

/**
 * @returns {string | undefined}
 */
function generateTermStartPreselect() {
	let now = moment();
	let year = now.year();
	if(now.isSameOrAfter(`${year}-01-01`) && now.isBefore(`${year}-03-15`)) {
		return `Spring ${year}`;
	}
	if(now.isSameOrAfter(`${year}-03-15`) && now.isBefore(`${year}-07-15`)) {
		return `Summer ${year}`;
	}
	if(now.isSameOrAfter(`${year}-07-15`) && now.isBefore(`${year}-10-15`)) {
		return `Fall ${year}`;
	}
	if(now.isSameOrAfter(`${year}-10-15`) && now.isBefore(`${year+1}-01-01`)) {
		return `Spring ${year + 1}`;
	}
}

export {
    dateFormated,
    convertTo24HrTime,
    anyNowOrAfter,
    generateTermStartPreselect,
};
